// Single source of truth for "where does the backend live".
//
// CRA inlines process.env.REACT_APP_* at BUILD time, so these come from
// .env.development (npm start) or .env.production (npm run build).
//
// The fallbacks derive the backend from the page's own origin, which is exactly
// right in production: the SPA, the REST API and the WebSocket are all served
// from https://exostrike.io by Caddy. Same origin => no CORS, no mixed content.

export const BACKEND_URL =
  process.env.REACT_APP_API_BASE || window.location.origin

// WebSocket URLs must be absolute — `new WebSocket('/ws/...')` is not valid,
// so we can't just use a relative path the way we can for REST.
export const WS_BASE =
  process.env.REACT_APP_WS_BASE ||
  `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}`

export const VAPID_PUBLIC_KEY =
  process.env.REACT_APP_VAPID_PUBLIC_KEY ||
  'BOGmJqRjUM-8lX3tZbfZt4Ivy0hA4SrSx1fAHWpKlpiqJ9xr35L4ApJiIJgoT-9INheM5WhbJnd0-8HdNON5X9Q'

// CRA reads .env* files ONCE, at dev-server startup. If you add or change one
// while `npm start` is running, the old (or missing) value stays baked in and
// every API call quietly goes to :3000 instead of :8000. Shout about it.
if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_API_BASE) {
  console.warn(
    `[config] REACT_APP_API_BASE is not set — falling back to ${BACKEND_URL}.\n` +
    'If .env.development exists, restart the dev server (Ctrl+C then npm start) to pick it up.'
  )
}
